import request from "@/utils/request";

export function login(data) {
  return request({
    // url: '/api/thearay/login',
    url: "/thearay/login",
    method: "post",
    data
  });
}

export function logout() {
  return request({
    // url: '/api/thearay/logout',
    url: "/thearay/logout",
    method: "get"
  });
}
